import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bd5be3be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "module content" }
const _hoisted_2 = { class: "container-site" }
const _hoisted_3 = { class: "secao-clientes" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "rotulo-secao" }, " Quem confia na LimaTec ", -1))
const _hoisted_5 = { class: "container-images" }
const _hoisted_6 = {
  id: "servicos",
  class: "secao-servicos fundo-grade"
}
const _hoisted_7 = { class: "container-site" }
const _hoisted_8 = { class: "cabecalho-servicos" }
const _hoisted_9 = { class: "titulos-servicos" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "rotulo-secao rotulo-amarelo" }, " Serviços ", -1))
const _hoisted_11 = { class: "titulo-secao" }
const _hoisted_12 = { class: "apoio-servicos" }
const _hoisted_13 = { class: "main-servico" }
const _hoisted_14 = { class: "module content" }
const _hoisted_15 = { class: "container-site" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeroPrincipal = _resolveComponent("HeroPrincipal")!
  const _component_FaixaNumeros = _resolveComponent("FaixaNumeros")!
  const _component_CaixaCliente = _resolveComponent("CaixaCliente")!
  const _component_SobreEmpresa = _resolveComponent("SobreEmpresa")!
  const _component_CaixaServico = _resolveComponent("CaixaServico")!
  const _component_SimuladorSolar = _resolveComponent("SimuladorSolar")!
  const _component_ChamadaOrcamento = _resolveComponent("ChamadaOrcamento")!
  const _component_ContatoIndex = _resolveComponent("ContatoIndex")!
  const _component_AvaliacoesGoogle = _resolveComponent("AvaliacoesGoogle")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HeroPrincipal, { TextoWhatsApp: "Olá, Gostaria de fazer um orçamento" }),
    _createVNode(_component_FaixaNumeros),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conteudo.clientes, (cliente) => {
              return (_openBlock(), _createBlock(_component_CaixaCliente, {
                key: cliente.imagem + cliente.nome,
                Imagem: _ctx.urlDaImagem(cliente.imagem),
                Nome: cliente.nome,
                height: `${cliente.altura ?? 80}px`
              }, null, 8, ["Imagem", "Nome", "height"]))
            }), 128))
          ])
        ]),
        _createVNode(_component_SobreEmpresa, {
          TituloPrimeiroParagrafo: "SOBRE NÓS",
          Titulo: _ctx.conteudo.sobre.titulo,
          TextoPrimerioPagrafo: _ctx.conteudo.sobre.paragrafo1,
          TextoSegundoPagrafo: _ctx.conteudo.sobre.paragrafo2
        }, null, 8, ["Titulo", "TextoPrimerioPagrafo", "TextoSegundoPagrafo"])
      ])
    ]),
    _createElementVNode("section", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("h2", _hoisted_11, _toDisplayString(_ctx.conteudo.servicosSecao.titulo), 1)
          ]),
          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.conteudo.servicosSecao.apoio), 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conteudo.servicos, (servico, i) => {
            return (_openBlock(), _createBlock(_component_CaixaServico, {
              key: servico.numero,
              Numero: servico.numero,
              Imagem: _ctx.imagensServicos[i % _ctx.imagensServicos.length],
              Texto: servico.texto,
              Titulo: servico.titulo,
              TextoWhatsApp: servico.whatsapp
            }, null, 8, ["Numero", "Imagem", "Texto", "Titulo", "TextoWhatsApp"]))
          }), 128))
        ])
      ])
    ]),
    _createVNode(_component_SimuladorSolar),
    _createVNode(_component_ChamadaOrcamento, {
      Titulo: _ctx.conteudo.chamada.titulo,
      SubTitulo: _ctx.conteudo.chamada.subtitulo,
      TextoWhatsApp: "Olá, Gostaria de fazer um orçamento"
    }, null, 8, ["Titulo", "SubTitulo"]),
    _createElementVNode("section", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_ContatoIndex, {
          TelefonePrimario: "",
          TelefoneSecundario: _ctx.conteudo.contato.telefone,
          TextoWhatsApp: "Preciso de um eletricista!",
          Logradouro: _ctx.conteudo.contato.logradouro,
          Cidade: _ctx.conteudo.contato.cidade,
          Cep: _ctx.conteudo.contato.cep,
          Pais: _ctx.conteudo.contato.pais,
          DiasAtendimento: _ctx.conteudo.contato.dias,
          HorasAtendimento: _ctx.conteudo.contato.horas
        }, null, 8, ["TelefoneSecundario", "Logradouro", "Cidade", "Cep", "Pais", "DiasAtendimento", "HorasAtendimento"])
      ])
    ]),
    _createVNode(_component_AvaliacoesGoogle)
  ], 64))
}